

import { Button } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";

function toCsv(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return "";

  const columns = Array.from(
    new Set(rows.flatMap((r) => Object.keys(r)))
  );

  const escape = (value) => {
    if (value === null || value === undefined) return "";
    const s = String(value);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };

  const header = columns.join(",");
  const body = rows
    .map((row) => columns.map((c) => escape(row[c])).join(","))
    .join("\n");

  return `${header}\n${body}`;
}

function downloadTextFile(filename, text) {
  const blob = new Blob([text], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();

  URL.revokeObjectURL(url);
}

export default function DownloadMetricRowsButton({ metricrows }) {
  const hasRows = Array.isArray(metricrows) && metricrows.length > 0;

  const handleDownload = () => {
    const csv = toCsv(metricrows);
    downloadTextFile("StackNZDash_Download.csv", csv);
  };

  return (
    <Button
      variant="outlined"
      startIcon={<DownloadIcon />}
      onClick={handleDownload}
      disabled={!hasRows}
      sx={{ mt: 4, width: "100%" }}
    >
      Download CSV
    </Button>
  );
}
